module.exports = __webpack_public_path__ + "908e4d2e/img/boston-lights.a623432f.png";